import RouteTemplate from "ember-route-template";
import or from "truth-helpers/helpers/or";

// NOTE: This route template no longer renders for users — the controller
// serves /best-for/:use_case as fully server-rendered HTML (crawler layout),
// and routes/proxyviews-best-for.js bounces in-app navigations to a full
// page load. It must merely COMPILE cleanly: any syntax/helper error here
// fails the whole plugin chunk, which breaks every Ember page's boot.
export default RouteTemplate(
  <template>
    <section class="pd-best-for">
      <header class="pd-best-for__hero">
        <div class="pd-best-for__hero-nav">
          <a class="pd-best-for__back" href="/best-for">← All use cases</a>
        </div>
        <h1 class="pd-best-for__title">{{@controller.model.title}}</h1>
        <p class="pd-best-for__subtitle">
          Ranked by verification tier, benchmark performance, and community rating.
        </p>
      </header>

      <div class="pd-best-for__ranked-list">
        {{#each (or @model.providers @controller.model.providers) as |p|}}
          <article class="pd-best-for__rank-item {{p.rankClass}}">
            {{#if p.isTop}}
              <div class="pd-best-for__ribbon"><span>🏆 Top Choice</span></div>
            {{/if}}
            <div class="pd-best-for__rank-num">{{p.rank}}</div>

            <div class="pd-best-for__card-body">
              <div class="pd-best-for__header-row">
                <div class="pd-best-for__logo">
                  {{#if p.logo_url}}
                    <img
                      src={{p.logo_url}}
                      alt={{p.name}}
                      class="pd-best-for__logo-img"
                      loading="lazy"
                    />
                  {{else}}
                    <span class="pd-card__logo-placeholder">{{p.logoInitial}}</span>
                  {{/if}}
                </div>
                <div class="pd-best-for__name-col">
                  <h3 class="pd-best-for__provider-name">{{p.name}}</h3>
                  {{#if p.shortDesc}}
                    <p class="pd-best-for__desc">{{p.shortDesc}}</p>
                  {{/if}}
                </div>
                <a class="pd-best-for__cta pd-best-for__cta--desktop" href={{p.url}}>View Details ↗</a>
              </div>

              {{#if p.specs}}
                <div class="pd-best-for__specs">
                  {{#each p.specs as |spec|}}
                    <span class="pd-best-for__spec">
                      <span class="pd-best-for__spec-icon">{{spec.icon}}</span>
                      {{spec.label}}
                    </span>
                  {{/each}}
                </div>
              {{/if}}

              <div class="pd-best-for__provider-meta">
                {{#if p.hasRating}}
                  <span class="pd-best-for__tag pd-best-for__tag--rating">★ {{p.ratingDisplay}}</span>
                {{else}}
                  <span class="pd-best-for__tag pd-best-for__tag--new">New</span>
                {{/if}}

                {{#if p.benchmarkDisplay}}
                  <span class="pd-best-for__tag pd-best-for__tag--benchmark">⚡ {{p.benchmarkDisplay}}</span>
                {{/if}}

                {{#if p.costDisplay}}
                  <span class="pd-best-for__tag pd-best-for__tag--cost">{{p.costDisplay}}</span>
                {{/if}}

                <span class="pd-best-for__tag pd-best-for__tag--type">{{p.proxyTypeLabel}}</span>

                {{#if p.verifiedLabel}}
                  <span class="pd-best-for__tag pd-best-for__tag--verified">✓ {{p.verifiedLabel}}</span>
                {{/if}}

                {{#if p.freeTrial}}
                  <span class="pd-best-for__tag pd-best-for__tag--trial">🆓 Free Trial</span>
                {{/if}}
              </div>

              <a class="pd-best-for__cta pd-best-for__cta--mobile" href={{p.url}}>View Details ↗</a>
            </div>
          </article>
        {{/each}}
      </div>
    </section>
  </template>
);
